<script>
  export let id

  import fetchO from '../../oauth.js'

  const fetchExercise = (async () => {
    const response = await fetchO('/exercises/' + id)
    return await response.json()
  })()
</script>

{#await fetchExercise}
  <p>...waiting</p>
{:then data}
  <h1>{data.name}</h1>
{:catch error}
  <p>An error occurred {error}!</p>
{/await}
